module.exports = __webpack_public_path__ + "img/san-diego-1904.f54fbe5f.png";